import { ReactNode } from "react";
import { Navigate } from "react-router";
import { useIsAdmin } from "./useIsAdmin";

// Wraps admin-only route elements. Non-admins are redirected to the dashboard instead of
// seeing a 403 from the backend — both layers are defensive (frontend UX, backend enforcement).
// While /api/me is in flight we render a placeholder: redirecting before the flags arrive
// would bounce legitimate admins to the dashboard on every hard refresh.
export default function RequireAdmin({ children }: { children: ReactNode }) {
  const { isAdmin, isLoading } = useIsAdmin();
  if (isLoading) return <div className="p-6 text-sm text-slate-600">Cargando…</div>;
  if (!isAdmin) return <Navigate to="/" replace />;
  return <>{children}</>;
}
